var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1H18V6H23V23H7V1Z",
    stroke: "#976821",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6L18 1V6H23Z",
    fill: "#FEEFD7",
    stroke: "#976821",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 18,
    height: 13,
    rx: 2,
    fill: "#FEEFD7",
    stroke: "#976821"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.5V12C6.5 11.4477 6.05228 11 5.5 11H4.5C3.94772 11 3.5 11.4477 3.5 12V17C3.5 17.5523 3.94772 18 4.5 18H5.5C6.05228 18 6.5 17.5523 6.5 17V16.5",
    stroke: "#976821",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.5V12C11.5 11.4477 11.0523 11 10.5 11H9.5C8.94772 11 8.5 11.4477 8.5 12V13.5C8.5 14.0523 8.94772 14.5 9.5 14.5H10.5C11.0523 14.5 11.5 14.9477 11.5 15.5V17C11.5 17.5523 11.0523 18 10.5 18H9.5C8.94772 18 8.5 17.5523 8.5 17V16.5",
    stroke: "#976821",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11L14.5 18H15.5L16.5 11",
    stroke: "#976821",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.fbf81735.svg";
export { ForwardRef as ReactComponent };